// import React from 'react';
namespace React { export type FC<T> = {}; export type Dispatch<T> = {}; export type SetStateAction<T> = {} };

import { DropDownBook, DropDownCategory } from '../models';

import { ReactCategory } from './ReactCategory';

interface TreeSelectProps
{
    initialized: boolean;
    books: { [id: number]: DropDownBook };
    categories: { [id: number]: DropDownCategory };
    enableFilter: boolean;
    filter: string;
    setBooks: React.Dispatch<React.SetStateAction<{
        [id: number]: DropDownBook;
    }>>;
    setCategories: React.Dispatch<React.SetStateAction<{
        [id: number]: DropDownCategory;
    }>>;
    setFilter: React.Dispatch<React.SetStateAction<string>>;
    rootCategoryId: number | null;
    // openAtStart: boolean;
    adapter: ReactTreeSelectAdapter;
    legacy: boolean;
    enableFavorites: boolean;
}

const ReactTreeSelect: React.FC<TreeSelectProps> = ({
    initialized,
    books,
    categories,
    enableFilter,
    filter,
    rootCategoryId,
    setBooks,
    setCategories,
    setFilter,
    // openAtStart,
    adapter,
    legacy,
    enableFavorites,
}) =>
{
    // TODO: rather mark filtered out books with a “skip/hidden” flag?
    // NOTE: the category selection logic is not broken by this (luckily)
    //       because bookIds are not filtered in (out of) their categories
    const filteredBooks = filterBooks(books, filter);
    // TODO: hide empty categories?
    const filteredCategories = categories;

    const handleCategorySelect = (categoryId: number, selected: boolean) =>
    {
        const updatedBooks: { [id: number]: DropDownBook } = { ...books };
        const updatedCategories: { [id: number]: DropDownCategory } = { ...categories };
        // const category = updatedCategories[categoryId];
        // category.selected = selected;

        const categoryIds = updateCategorySelection(
            categoryId, selected, updatedBooks, updatedCategories);

        // const categoryIds = [category.parentCategoryId];
        updateAncestorCategories(
            categoryIds, updatedBooks, updatedCategories, false);

        if (legacy) {

        adapter.sendOutboundMessage('updateState', {
            categories: {
                [categoryId]: {
                    selected
                }
            }
        });

        } else { // !legacy
            adapter.sendFullState(updatedBooks, updatedCategories);
        }

        setBooks(updatedBooks);
        setCategories(updatedCategories);
    };

    const handleCategoryOpenClose = (categoryId: number, isOpen: boolean) =>
    {
        const updatedCategories: { [id: number]: DropDownCategory } = { ...categories };
        const category = updatedCategories[categoryId];

        if (!category) {
            console.warn('No category', categoryId, 'in', categories);
            return;
        }

        category.isOpen = isOpen;

        if (legacy) {

        adapter.sendOutboundMessage('updateState', {
            categories: {
                [categoryId]: {
                    isOpen,
                }
            }
        });

        } // legacy

        setCategories(updatedCategories);
    };

    const handleBookSelect = (bookId: number, selected: boolean) =>
    {
        const updatedBooks: { [id: number]: DropDownBook } = { ...books };
        const book = updatedBooks[bookId];
        book.selected = selected;

        const categoryIds = book.categoryIds;
        const updatedCategories = { ...categories };
        updateAncestorCategories(
            categoryIds, updatedBooks, updatedCategories, false);

        if (legacy) {

        adapter.sendOutboundMessage('updateState', {
            books: {
                [bookId]: {
                    selected,
                }
            }
        });

        } else { // !legacy
            adapter.sendFullState(updatedBooks, updatedCategories);
        }

        setBooks(updatedBooks);
        setCategories(updatedCategories);
    };

    const handleFilterChange = (query: string) =>
    {
        setFilter(query);
    }

    return (
        <div className="dropdown-select books-select">
            {/* rootCategoryId !== null && ( */
                // @ts-ignore
                <ReactCategory
                    initialized={initialized}
                    categoryId={rootCategoryId}
                    books={filteredBooks}
                    categories={filteredCategories}
                    enableFavorites={enableFavorites}
                    enableFilter={enableFilter}
                    filter={filter}
                    onCategorySelect={handleCategorySelect}
                    onCategoryOpenClose={handleCategoryOpenClose}
                    onBookSelect={handleBookSelect}
                    isRoot={true}
                    onFilterChange={handleFilterChange}
                />
            /* ) */}
        </div>
    );
};

const updateCategorySelection = (
    // category: DropDownCategory,
    seedCategoryId: number,
    selected: boolean,
    updatedBooks: { [id: number]: DropDownBook },
    updatedCategories: { [id: number]: DropDownCategory },
):
    Array<number> =>
{
    // const selected = category.selected;
    const affectedCategoryIds = {}; // category.parentCategoryId

    const categoryIds = [seedCategoryId]; // category.id

    while (categoryIds.length) {
        const categoryId = categoryIds.shift() as number;
        const category = updatedCategories[categoryId];

        category.selected = selected;

        for (let bookId of category.bookIds) {
            const book = updatedBooks[bookId];
            book.selected = selected;

            for (let bookCategoryId of book.categoryIds)
                affectedCategoryIds[bookCategoryId] = true;
        }

        categoryIds.push(...category.subcategoryIds);
    }

    return Object.keys(affectedCategoryIds).map((n) => parseInt(n));
}

const updateAncestorCategories = (
    // downlevelIteration? => nope, rather use ES2015 (ES6)
    categoryIds: Array<number> | Set<number>,
    updatedBooks: { [id: number]: DropDownBook },
    updatedCategories: { [id: number]: DropDownCategory },
    propagateIsOpen: boolean,
) =>
{
    for (let seedCategoryId of categoryIds) {
        let categoryId = seedCategoryId;

        while (categoryId !== null) {
            const category: DropDownCategory = updatedCategories[categoryId];

            updateCategory(
                category, updatedBooks, updatedCategories, propagateIsOpen);

            categoryId = category.parentCategoryId;
        }
    }

    // console.info(updatedBooks, updatedCategories, categoryIds);
};

const updateCategory = (
    category: DropDownCategory,
    updatedBooks: { [id: number]: DropDownBook },
    updatedCategories: { [id: number]: DropDownCategory },
    propagateIsOpen: boolean,
) =>
{
    const itemsStatus = []; // selection
    let isOpen = false;

    // TODO: introduce iterators as helpers?
    for (let bookId of category.bookIds) {
        const book = updatedBooks[bookId] as DropDownBook;

        itemsStatus.push(book.selected);

        if (book.selected)
            isOpen = true;
    }

    for (let categoryId of category.subcategoryIds) {
        const category = updatedCategories[categoryId] as DropDownCategory;

        itemsStatus.push(category.selected);

        if (category.isOpen)
            isOpen = true;
    }

    if (itemsStatus.length == 0)
        return;

    let status = itemsStatus[0];

    for (let itemStatus of itemsStatus.slice(1)) {
        // partially selected subcategory => we are as well
        if (itemStatus === null) {
            status = null;
            break;
        }

        if (status === itemStatus)
            continue;

        // only some items are selected => checkbox.indeterminate = true
        status = null;
        break;
    }

    category.selected = status;

    if (propagateIsOpen && isOpen) {
        category.isOpen = true;
    }
}

const filterBooks = (books: { [id: number]: DropDownBook }, filter: string) =>
{
    const booksList = Object.values(books);

    let regex: RegExp = null;

    try {
        // https://stackoverflow.com/questions/494035/how-do-you-use-a-variable-in-a-regular-expression
        // String.raw`${filter}`
        regex = new RegExp(filter, 'i');

    } catch (e) {
        // SyntaxError
        console.warn(e);

        return [];
    }

    const filteredBooks = booksList.filter((book: DropDownBook) =>
    {
        // TODO: author(s), year(s)

        if (book.name?.match(regex))
            return true;

        if (book.sourceAbbreviation?.match(regex))
            return true;

        if (book.sourcePartAbbreviation?.match(regex))
            return true;

        if (book.linkingAbbreviation?.match(regex))
            return true;

        return false;
    });

    return Object.fromEntries(
        filteredBooks.map(
            (book) => [book.id, book]
        ));
}

//  XXX: default exports are not supported by the loadUMD2GlobalHack
export {
    ReactTreeSelect,
    updateCategorySelection,
    updateAncestorCategories,
    updateCategory,
};
